
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aolCq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cc49cf2ca07c21cab00e1bdfbed6dc50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $790cea4d01625bae$var$_react = $790cea4d01625bae$var$_interopRequireDefault((parcelRequire("42omo")));

var $790cea4d01625bae$var$_baseNew = $790cea4d01625bae$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $790cea4d01625bae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoSkipBackwardFifteen".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video-skip-backward-fifteen
 * Usage guidance:
 * Reserved for skipping video content backward by 15 seconds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $790cea4d01625bae$var$VideoSkipBackwardFifteenIcon = (props)=>/*#__PURE__*/ $790cea4d01625bae$var$_react.default.createElement($790cea4d01625bae$var$_baseNew.default, Object.assign({
        name: "VideoSkipBackwardFifteenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.81 3.75 2.47-2.47L3.22.22l-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m6.06 4.5 1.72 1.72-1.06 1.06-3-3a.75.75 0 0 1 0-1.06l3-3 1.06 1.06L6.06 3h5.69A3.25 3.25 0 0 1 15 6.25v3.5A3.25 3.25 0 0 1 11.75 13H11v-1.5h.75a1.75 1.75 0 0 0 1.75-1.75v-3.5a1.75 1.75 0 0 0-1.75-1.75zM1 9.5h1.75a.75.75 0 0 1 .75.75V16H2v-5H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9 9.5H5.75a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75H7.5v1H5V16h2.625C8.385 16 9 15.384 9 14.625v-1.25C9 12.615 8.384 12 7.625 12H6.5v-1H9z" clip-rule="evenodd"/>`
    }, props));
$790cea4d01625bae$var$VideoSkipBackwardFifteenIcon.displayName = 'VideoSkipBackwardFifteenIcon';
var $790cea4d01625bae$var$_default = module.exports.default = $790cea4d01625bae$var$VideoSkipBackwardFifteenIcon;

});


//# sourceMappingURL=video-skip-backward-fifteen.7d60ceff.js.map
